import { MatxLoadable } from "matx";
import { authRoles } from "../../auth/authRoles";

const UpdateLetterSingle = MatxLoadable({
    loader: () =>
        import ("./UpdateLetterSingle")
})
const AllUpdateLetterSingle = MatxLoadable({
    loader: () =>
        import ("./AllUpdateLetterSingle")
})




// const settings = {
//     activeLayout: "layout1",
//     layout1Settings: {
//         topbar: {
//             show: false
//         },
//         leftSidebar: {
//             show: false,
//             mode: "close"
//         }
//     },
//     layout2Settings: {
//         mode: "full",
//         topbar: {
//             show: false
//         },
//         navbar: { show: false }
//     },
//     secondarySidebar: { show: false },
//     footer: { show: false }
// };

const UpdateLetterSingleRoutes = [
    {
        path: "/update_letter_single",
        component: AllUpdateLetterSingle,
        // settings
    },

];

export default UpdateLetterSingleRoutes;